// @module Tavano.TT_TariffMessage.TariffMessage
define('Tavano.TT_TariffMessage.TariffMessage.View'
	, [
		'tavano_tt_tariffmessage_tariffmessage.tpl'
		, 'Backbone'
	]
	, function (
		tavano_tt_tariffmessage_tariffmessage_tpl
		, Backbone
	) {
		'use strict';

		// @class Tavano.TT_TariffMessage.TariffMessage.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavano_tt_tariffmessage_tariffmessage_tpl

			, initialize: function (options) {
				this.container = options.container;
				this.environment = this.container.getComponent('Environment');
				this.message = this.environment.getConfig('tavano.tariffMessage');
				this.iteminfo = options.pdp.getItemInfo();

			}

			, events: {
			}

			, bindings: {
			}

			, childViews: {

			}

			//@method getContext @return Tavano.TT_TariffMessage.TariffMessage.View.Context
			, getContext: function getContext() {
				//@class Tavano.TT_TariffMessage.TariffMessage.View.Context
				this.message = this.message;
				var tariff = this.iteminfo.item.custitem_manufacturertariff;
				var itemManufacturerCountry = this.iteminfo.item.countryofmanufacture;
				var showTarriffMessage = false;
				if (tariff !== "" && tariff !== null && tariff !== undefined) {
						showTarriffMessage = true;
				}
				return {
					message: this.message,
					showTarriffMessage: showTarriffMessage,
					tariff : tariff,
					originCountry : itemManufacturerCountry
				};
			}
		});
	});
